const UPDATE_CITY = 'UPDATE_CITY';
const UPDATE_POSITION_STATUS = 'UPDATE_POSITION_STATUS';
const UPDATE_ADDRESS_INFO = 'UPDATE_ADDRESS_INFO';
const UPDATE_LOCALADDRESS = 'UPDATE_LOCALADDRESS';
const UPDATE_CURRENT = 'UPDATE_CURRENT';

export default {
  UPDATE_CITY,
  UPDATE_POSITION_STATUS,
  UPDATE_ADDRESS_INFO,
  UPDATE_LOCALADDRESS,
  UPDATE_CURRENT
};



// WEBPACK FOOTER //
// ./src/stores/location/_types.js